import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import Utils from 'app/Utils';

@Injectable()
export class AuthGuard  {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean{
        //Comprobamos la validez del token
        var token = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))).token;
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        var jsonToken = JSON.parse(jsonPayload);
        var date = new Date(jsonToken.exp * 1000);
        var fechaActual = new Date();
        //cerramos sesion
        if (date < fechaActual) {
            this.router.navigate(['/']);
            localStorage.removeItem('currentUser');
            localStorage.removeItem('permissionIds');
            localStorage.removeItem('Empresa');
            localStorage.removeItem('SelectedCompanyName');
            localStorage.removeItem('companiesForTreeView');
            // This is checked and API details are called before login
            localStorage.removeItem('EmplooyeeID');
            localStorage.removeItem('SMSVarifyCode');
        }

        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/']);
        return false;
    }
}
